import React from "react";
import PublicPage from "../../public/PublicPage";
import VehiclesPage from "../../public/pages/VehiclesPage";

const Vehicles = () => (
  <PublicPage>
    <VehiclesPage />
  </PublicPage>
);

export default Vehicles;
